export const renewableEnergy = {
  market: '市场',
  optionsAvailable: '可用选项',
  pdf: 'PDF'
};
